import type { VoidFunctionComponent } from 'react';

import useGetProjectDependency, {
  getProjectDependencyQueryKey,
} from '../../../../hooks/api/dependencies/useGetProjectDependency';
import queryClient from '../../../../ReactQuery/client';

import DependencyDrawer from './DependencyDrawer';
import type { DrawerScope } from './types';

type Props = {
  onClose: () => void;
  projectRevisionLocator: string;
  dependencyRevisionLocator: string;
  /**
   * The revision scan to show issues from. Defaults to the revision's latest scan.
   */
  revisionScanId?: number;
  scope: DrawerScope;

  /**
   * A callback that's performed when a dependency is ignored or deleted.
   */
    onDeleteDependency: (locator: string) => void;
    /**
     * A callback that's performed when a dependency is edited.
     */
    onEditDependency?: () => void;
};

const ProjectDependencyDrawer: VoidFunctionComponent<Props> = ({
  onClose,
  projectRevisionLocator,
  dependencyRevisionLocator,
  revisionScanId,
  scope,
  onDeleteDependency,
  onEditDependency,
}) => {
  const { data, isLoading } = useGetProjectDependency(
    projectRevisionLocator,
    dependencyRevisionLocator,
    true,
    revisionScanId,
  );

  return (
    <DependencyDrawer
      onClose={onClose}
      dependency={data?.dependency ?? null}
      isLoading={isLoading}
      onDeleteDependency={onDeleteDependency}
      onEditDependency={() => {
        queryClient.invalidateQueries({
          queryKey: getProjectDependencyQueryKey(projectRevisionLocator, dependencyRevisionLocator),
        });
        onEditDependency?.();
      }}
      scope={scope}
    />
  );
};

export default ProjectDependencyDrawer;
